import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import Healthcare from "../containers/healthcare";

const Solutions = () => {
  return (
    <React.Fragment>
      <Layout>
        <SEO title="Grey codes – Solutions" />
        <div className="wrapper">
          <Header />
          <PageBanner
            title="Healthcare Investments"
            excerpt="
            Welcome to Grey codes Solutions , your premier destination for healthcare investment consultancy services"
            image="./images/faq/1.png"
          />
          <Healthcare />
          <NewsletterArea />
          <Footer />
          <ScrollToTop />
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default Solutions;
